module.exports = __webpack_public_path__ + "static/media/login-banner4.28cbf616.jpg";